import { toast } from "sonner";
import { api, track, siteUrl } from "@/lib/api";
import { errorKey } from "@/lib/i18n";
import { useApp } from "@/context/AppContext";

export const useContact = () => {
  const { t } = useApp();
  return async (post) => {
    try {
      const { data } = await api.post(`/posts/${post.id}/contact`);
      if (data.demo) { toast(t("seller_unreachable"), { className: "dm-faint-toast", duration: 3500 }); return; }
      if (!data.available) { toast(t("poster_unverified")); return; }
      const url = `https://wa.me/${data.phone}?text=${encodeURIComponent(data.message)}`;
      const w = window.open(url, "_blank", "noopener");
      if (!w) window.location.href = url;
    } catch (e) {
      const code = errorKey(e);
      toast.error(t(code === "error" && e?.response?.status === 429 ? "slow_down" : code));
    }
  };
};

export const useShare = () => {
  const { t, L, hubOf, lang } = useApp();
  return async (post) => {
    const url = `${siteUrl()}/post/${post.id}?via=share`;
    const money = post.price != null && !post.contact_for_price
      ? ` — ${new Intl.NumberFormat(lang === "fr" ? "fr-CA" : "en-CA", { style: "currency", currency: "CAD", maximumFractionDigits: 0 }).format(post.price)}` : "";
    const text = t(post.type === "request" ? "share_post_request" : "share_post_listing", { title: post.title, hub: L(hubOf(post.hub_id)), price: money });
    track("share_click", { post_id: post.id });
    const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (navigator.share && mobile) {
      try { await navigator.share({ title: post.title, text, url }); } catch { /* cancelled */ }
      return;
    }
    try { await navigator.clipboard.writeText(`${text} ${url}`); } catch {
      const ta = document.createElement("textarea"); ta.value = `${text} ${url}`; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    toast.success(t("link_copied"));
  };
};
